import { render, staticRenderFns } from "./ConsultantFees.vue?vue&type=template&id=69303754&scoped=true&"
import script from "./ConsultantFees.vue?vue&type=script&lang=js&"
export * from "./ConsultantFees.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantFees.vue?vue&type=style&index=0&id=69303754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69303754",
  null
  
)

export default component.exports